import { Routes, Route, Navigate } from "react-router-dom";

import BrainLayout from "./layout";
import Files from "./files";
import Onboard from "./onboard";

export default function Brain() {
  return (
    <Routes>
      <Route element={<BrainLayout />}>
        <Route path="files" element={<Files />} />
        <Route path="onboard" element={<Onboard />} />
        <Route path="" element={<Navigate to="files" replace />} />
      </Route>
    </Routes>
  );
}
